export { default } from "./InventoryDetail";

